import { types } from 'mobx-state-tree';
import isEqual from 'lodash.isequal';
import FilterOptionModel from './FilterOptionModel';

const CheckboxFilterModel = types
    .model('CheckboxFilter', {
        name: types.string,
        title: types.string,
        options: types.array(FilterOptionModel),
        type: types.literal('Checkbox'),
        value: types.array(types.string),
    })
    .views(self => ({
        get selectedOptions() {
            return self.options.filter(option => self.value.includes(option.value));
        },

        get valueForQuery() {
            return [...self.value].length ? [...self.value] : [];
        },

        isMatch(value = []) {
            return isEqual(self.valueForQuery, value);
        },
    }))
    .actions(self => ({
        setValue(value = []) {
            self.value = value;
        },

        clear(optionValue) {
            self.value.remove(optionValue);
        },

        reset() {
            self.value = [];
        },
    }));

export default CheckboxFilterModel;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/models/CheckboxFilterModel.js